import { render, staticRenderFns } from "./MeiTuanRedeem.vue?vue&type=template&id=5d66a582&scoped=true"
import script from "./MeiTuanRedeem.vue?vue&type=script&lang=js"
export * from "./MeiTuanRedeem.vue?vue&type=script&lang=js"
import style0 from "./MeiTuanRedeem.vue?vue&type=style&index=0&id=5d66a582&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d66a582",
  null
  
)

export default component.exports